export const PROFILE_CABINET_ONBOARDING_VERSION = 1;

export function buildProfileCabinetOnboardingStorageKey(
    userId
) {
    if (
        userId === null ||
        userId === undefined ||
        userId === ""
    ) {
        return null;
    }

    return [
        "profile-onboarding",
        "cabinet-location",
        `v${PROFILE_CABINET_ONBOARDING_VERSION}`,
        String(userId),
    ].join(":");
}

export function shouldShowProfileCabinetOnboarding({
    userId,
    hasSeen,
}) {
    return Boolean(
        buildProfileCabinetOnboardingStorageKey(userId) &&
        !hasSeen
    );
}
